/* @refresh reload */
import { render } from "solid-js/web";
import { App } from "./App";
import "@/styles/theme.css";

const root = document.getElementById("app");
if (!root) throw new Error("#app not found");
render(() => <App />, root);
